import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { useChangePasswordMutation } from "@/services";
import { toast } from "sonner";
import { getRequiredFields, removeEmptyFields } from "@/lib/utils";
import { schema } from "./validations";
import { CONFIRM_PASSWORD, CURRENT_PASSWORD, NEW_PASSWORD } from "./consts";
import { routes } from "@/routes/utils";

const useChangePassword = () => {
  const navigate = useNavigate();
  const [showConfirmMsg, setShowConfirmMsg] = useState<boolean>(false);
  const [isPassword, setIsPassword] = useState<any>({
    current: true,
    newPassword: true,
    confirm: true,
  });

  const form = useForm<any>({
    defaultValues: {
      [CURRENT_PASSWORD]: "",
      [NEW_PASSWORD]: "",
      [CONFIRM_PASSWORD]: "",
    },
    resolver: zodResolver(schema),
  });

  // Dynamically determine required fields
  const requiredFields = getRequiredFields(schema);

  const { mutate: changePasswordMutate, isPending: isChangePasswordPending } =
    useChangePasswordMutation({
      onError: (error?: any) => {
        toast.error(
          typeof error?.response?.data?.issues?.message === "string"
            ? error?.response?.data?.issues?.message :
          typeof error?.response?.data?.message === "string"
            ? error?.response?.data?.message
            : "Something went wrong",
          {
            className: "!bg-red-500 !text-white",
          }
        );
        return error?.response?.data?.message;
      },
      onSuccess: () => {
        setShowConfirmMsg(true);
      },
    });

  const onSubmit = (data: any) => {
    const _data = removeEmptyFields(data);

    if (_data[NEW_PASSWORD] != _data[CONFIRM_PASSWORD]) {
      form.setError(CONFIRM_PASSWORD, {
        message: "New Password and Confirm Password must match.",
      });
      return;
    }
    delete _data[CONFIRM_PASSWORD];
    changePasswordMutate({ data: _data });
  };

  const onEyeIconClick = (key: string) => () => {
    setIsPassword({ ...isPassword, [key]: !isPassword[key] });
  };

  const Icon = isPassword ? Eye : EyeOff;

  const onOkClick = () => {
    navigate(`/${routes.admin}`);
  };

  return {
    navigate,
    form,
    requiredFields,
    onSubmit,
    onEyeIconClick,
    isPassword,
    Icon,
    isChangePasswordPending,
    showConfirmMsg,
    onOkClick,
  };
};

export default useChangePassword;
